import { Box, Stack, Text } from "@mantine/core"
import { useSuspenseQueryGet } from "../../../typed-client/hooks/use-suspense-query-get"
import { ValidateCodeForm } from "./validate-code-form"
import { AuthenticatorAppStack } from "./authenticator-app-stack"
import { ResendCodeForm } from "./resend-code-form"
import { AuthenticationFactorType_AllValues } from "../../../@client/Theasoft_DataTypes_Enums"
import { useTranslation } from "react-i18next"

interface Props {
  userAuthenticationFactorId: number
  onSuccess: () => void
  onCancel: () => void
}

export function ValidateAuthenticationFactorStack({
  userAuthenticationFactorId,
  onSuccess,
  onCancel,
}: Props) {
  const { data: userAuthenticationFactor } = useSuspenseQueryGet(
    "/api/UserAuthenticationFactor/GetUserAuthenticationFactor",
    { userAuthenticationFactorId }
  )
  const { t } = useTranslation("app_server")

  return (
    <Stack align="center">
      {userAuthenticationFactor.authenticationFactorType ===
      AuthenticationFactorType_AllValues[1] ? (
        <ResendCodeForm
          userAuthenticationFactorId={userAuthenticationFactorId}
        />
      ) : null}
      {userAuthenticationFactor.authenticationFactorType ===
        AuthenticationFactorType_AllValues[0] &&
      !userAuthenticationFactor.confirmedAt ? (
        <AuthenticatorAppStack
          userAuthenticationFactorId={userAuthenticationFactorId}
        />
      ) : null}
      <Text>
        {t("UserAuthenticationFactor_EnterCodeMeassage", {
          0: userAuthenticationFactor.name,
        })}
      </Text>
      <Box w={"100%"}>
        <ValidateCodeForm
          onSuccess={onSuccess}
          onCancel={onCancel}
          userAuthenticationFactorId={userAuthenticationFactorId}
        />
      </Box>
    </Stack>
  )
}
